export default __webpack_public_path__ + "static/1350-55e2aa0601f7b6d2de33c67cc55556cf.gif";